import axios from '@/lib/axios'
import {
  buildAdminRequestConfig,
  type OrganizationId,
  type ScopedAdminQueryKey,
  type ScopedAdminQueryRoot,
} from '@/lib/organization-scoping'
import type { QueryFunctionContext } from '@tanstack/react-query'
import type {
  OrganizationTaxSettings,
  OrganizationTaxSettingsInput,
  TaxRateSuggestion,
} from './organization-tax-settings.types'

export type TaxRateSuggestionQueryKey = [
  ScopedAdminQueryRoot,
  { scope: 'rate-suggestion'; locationId: number | undefined },
]

export async function getOrganizationTaxSettings({
  queryKey: [{ organizationId }],
}: QueryFunctionContext<ScopedAdminQueryKey>) {
  return axios.get<OrganizationTaxSettings>(
    '/tax-settings',
    buildAdminRequestConfig({ organizationId })
  )
}

export async function updateOrganizationTaxSettings({
  organizationId,
  ...values
}: OrganizationTaxSettingsInput & { organizationId: OrganizationId }) {
  return axios.put<OrganizationTaxSettings>(
    '/tax-settings',
    values,
    buildAdminRequestConfig({ organizationId })
  )
}

export async function getTaxRateSuggestion({
  queryKey: [{ organizationId }, { locationId }],
}: Pick<QueryFunctionContext<TaxRateSuggestionQueryKey>, 'queryKey'>) {
  return axios.get<TaxRateSuggestion>(
    '/tax-settings/rate-suggestion',
    buildAdminRequestConfig({
      organizationId,
      params: locationId == null ? {} : { location_id: locationId },
    })
  )
}
